import React, { useState } from "react";
export const Confirm = () => {
  const [codigo, setCodigo] = useState("");

  const captureTypeCodigo = (e) => {
    setCodigo(e.target.value);
    console.log(e.target.value);
  };

  return (
    <>
      <section className="confirmation2">
        <section className="confirm2">
          <div>
            {/* <a
              href={`https://api.whatsapp.com/send?phone=3112857138&text=Hola,%20¿qué%20tal%20Quisera%20confirmar%20mi%20Asistencia.%20Adultos:%20${adultos},%20Niños:%20${ninos},%20Personas:%20${nombres}`}
              type="button"
              class="btn btn-dark"
              style={{
                alignItems: "center",
                justifyContent: "center",
                marginLeft: "6em",
                marginTop:"2em"
              }}
            >
              CONFIRMA AQUI
            </a> */}
          </div>
        </section>
      </section>
      <section className="confirmation3">
        <section className="confirm3">
          <div>
            <h5>Sabado 23 de Dic | Iglesia de Fatima</h5>
            <h2
              style={{
                alignItems: "center",
                justifyContent: "center",
                marginLeft: "1em",
                marginTop: "1em",
              }}
            >
              BODA CESAR Y PALOMA
            </h2>
            <br />
            <input
              name="codigo"
              type="text"
              class="form-control"
              placeholder="Introduce tu codigo"
              onChange={captureTypeCodigo}
              value={codigo}
            ></input>

            <a
              href={`https://api.whatsapp.com/send?phone=3330071954&text=Hola,%20¡Qué%20tal%20quisera%20confirmar%20mi%20asistencia!.%20Mi%20código:%20${codigo}`}
              type="button"
              class="btn btn-dark"
              style={{
                alignItems: "center",
                justifyContent: "center",
                marginLeft: "6em",
                marginTop: "2em",
                backgroundColor: "#942838",
              }}
            >
              CONFIRMA AQUI
            </a>
          </div>
        </section>
      </section>
    </>
  );
};
